import { ContentBreadcrumbFragment } from "__generated__/types";

export const exampleAuthor = "Gustav";
export enum ContentStatusFilterValue {
  ALL = "ALL",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export const contentNorwegianName: Record<
  ContentBreadcrumbFragment["__typename"],
  string
> = {
  Folder: "Mappe",
  Kurssloeyfe: "Kurssløyfe",
  ExamSyllabus: "Eksamenspensum",
  StudyProgramme: "Studieprogram",
  Article: "Artikkel",
  MultipleChoice: "Flervalgsoppgave",
};

export const REQUIRED_FORM_FIELD = "Du må fylle ut dette feltet";
